import {SxType} from "@baseTypes/sx/sxTypes";
import {SV_LIGHT} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
	icon: {
		width: '18px',
		height: '18px',
	},
	innerIcon: {
		paddingTop: '7px',
		paddingRight: '6px'
	},
	nameInner: {
		backgroundColor: SV_LIGHT.accentSoft,
		padding: '2px 8px ',
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
		borderRadius: '5px',
	},
	
	name: {
		fontSize: '16px',
		fontWeight: '600',
		'.lightTheme &': {
			color: '#222'
		},
		whiteSpace: 'nowrap',
		overflow: 'hidden'
	},
	btn: {
		flexShrink: 0
	},
	iconEdit: {
		width: '20px',
		height: '20px',
		transition: 'all .3s',
		'&:hover': {
			cursor: 'pointer'
		}
	},
	wrapper: {
		flexShrink: 0,
		alignItems: 'flex-start',
	},
	
	address: {
		flexShrink: 0,
		color: SV_LIGHT.accent,
		fontSize: '10px',
		display: 'flex',
		gap: '3px',
		alignItems: 'center'
	},
	info: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px'
	}
}